import React from 'react';
import { Mail, Phone, MapPin, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{
      backgroundColor: '#000000',
      borderTop: '1px solid rgba(255, 255, 255, 0.25)',
      padding: '60px 7.6923%'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '40px',
          marginBottom: '40px'
        }}>
          {/* Company Info */}
          <div>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#00FFD1',
              marginBottom: '16px'
            }}>INDUSTRIA 4.0</h3>
            <p style={{
              fontSize: '16px',
              color: 'rgba(255, 255, 255, 0.85)',
              lineHeight: 1.5,
              marginBottom: '20px'
            }}>
              Transformando el futuro de la industria con tecnología de vanguardia.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 style={{
              fontSize: '18px',
              fontWeight: 600,
              color: '#FFFFFF',
              marginBottom: '16px'
            }}>Servicios</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {['Big Data', 'Machine Learning', 'Blockchain', 'IoT'].map((service) => (
                <li key={service} style={{ marginBottom: '8px' }}>
                  <a href="#servicios" style={{
                    fontSize: '16px',
                    color: '#4D4D4D',
                    textDecoration: 'none',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#00FFD1'}
                  onMouseLeave={(e) => e.target.style.color = '#4D4D4D'}>
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 style={{
              fontSize: '18px',
              fontWeight: 600,
              color: '#FFFFFF',
              marginBottom: '16px'
            }}>Contacto</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Mail size={18} style={{ color: '#00FFD1' }} />
                <span style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)' }}>aaranar@smartfactorychain.com</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Phone size={18} style={{ color: '#00FFD1' }} />
                <span style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)' }}>+51 942 149115</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <MapPin size={18} style={{ color: '#00FFD1' }} />
                <span style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)' }}>Cajamarca, Peru</span>
              </div>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h4 style={{
              fontSize: '18px',
              fontWeight: 600,
              color: '#FFFFFF',
              marginBottom: '16px'
            }}>Síguenos</h4>
            <div style={{ display: 'flex', gap: '16px' }}>
              <a href="#" style={{
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                color: '#FFFFFF',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#00FFD1';
                e.currentTarget.style.color = '#00FFD1';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.25)';
                e.currentTarget.style.color = '#FFFFFF';
              }}>
                <Linkedin size={20} />
              </a>
              <a href="#" style={{
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                color: '#FFFFFF',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#00FFD1';
                e.currentTarget.style.color = '#00FFD1';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.25)';
                e.currentTarget.style.color = '#FFFFFF';
              }}>
                <Twitter size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.25)',
          paddingTop: '24px',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '16px',
            color: '#4D4D4D',
            margin: 0
          }}>
            © 2025 Industria 4.0. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;